import store from "@/store";
import hash from "object-hash";

const History = {
  add: (data, key = null) => {
    if (!key) {
      key = hash(data);
    }

    if (typeof key !== "string") {
      key = hash(key);
    }

    store.commit("history/ADD", { key, data });

    return key;
  },
  get: (key) => {
    return store.getters["history/record"](key);
  },
  exist: (key) => {
    return key in store.state.history.record;
  },
  all: () => {
    return store.state.history.record;
  },
};

export default {
  computed: {
    $history() {
      return History;
    },
    historyKey() {
      return this.$route.query.h;
    },
  },
};
